import gql from 'graphql-tag';

export const getOrganisationStockAccessQuery = gql`
  query GetOrganisationStockAccess($organisationId: String!) {
    getOrganisation(organisationId: $organisationId) {
      shutterstockAccess
    }
  }
`;

export default () => ({
  query: getOrganisationStockAccessQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: ({ organisationId }: { organisationId: string }) => ({
    organisationId
  })
});
